import React from 'react';
import { standingOrdersRecurringNames } from 'lib/constants';
import dayjs from 'dayjs';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import { formatMoney } from 'lib/utils';

export interface StandingOrderTextProps {
    amount: number;
    recurType: number;
    startOn: string;
    endOn?: string;
    selectedPayee: {
        payeeName: string;
        accountNo: string | number;
        sortCode: string | number;
    };
}

const StandingOrderText = ({
    amount,
    recurType,
    startOn,
    endOn,
    selectedPayee,
}: StandingOrderTextProps) => {
    const translate = useTranslate('standingOrders.confirmModal');
    return (
        <>
            <Typography>{translate('youAreAboutToSend')}</Typography>
            <Typography tag="h2">£{formatMoney(amount * 100)}</Typography>
            <Typography>{selectedPayee.payeeName}</Typography>
            <Typography>Acc No {selectedPayee.accountNo}</Typography>
            <Typography>{selectedPayee.sortCode}</Typography>
            <Typography>{translate('on')}</Typography>
            <Typography tag="h2">
                {dayjs(startOn).format('DD/MM/YYYY')}
            </Typography>
            <Typography>
                {translate('sendBasis', {
                    recurType: standingOrdersRecurringNames[recurType],
                })}
            </Typography>
            <Typography tag="h2">
                {endOn ? dayjs(endOn).format('DD/MM/YYYY') : '-'}
            </Typography>
            <Typography>{translate('isThisCorrect')}</Typography>
        </>
    );
};

export default StandingOrderText;
